import SelectKeys from '../../constants-v2/state/select-keys';

const getBaseSelectedObject = () => ({
  items: [],
  ignored: [],
  selectedAll: false,
});

const state = {
  selected: {
    [SelectKeys.AGREEMENT_PRICE_INCREASE]: getBaseSelectedObject(),
  },
};

const mutations = {
  addSelectedRow(state, {
    id,
    key,
  }) {

    if (!state.selected[key]) {
      throw new Error(`Unknown selected key: [${ key }]`);
    }

    if (state.selected[key].selectedAll) {
      state.selected[key].ignored = state.selected[key].items.filter(el => el !== id);
    }

    state.selected[key].items.push(id);
  },
  removeSelectedRow(state, {
    id,
    key,
  }) {
    if (!state.selected[key]) {
      throw new Error(`Unknown selected key: [${ key }]`);
    }

    if (state.selected[key].selectedAll) {
      state.selected[key].ignored.push(id);

      return;
    }

    state.selected[key].items = state.selected[key].items.filter(el => el !== id);
  },

  setSelectedAll(state, { key, value }) {
    state.selected[key] = getBaseSelectedObject();
    state.selected[key].selectedAll = value;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
